import { useState } from 'react';
import { SalaryTable } from './salary-table';
import { SalaryCalculation } from './salary-calculation';
import { useGetManagerMonthlySalary } from '@entities/managers-perfomance';

const now = new Date();
const prevMonthDate = new Date(now.getFullYear(), now.getMonth() - 1, 1);
const defaultMonth = prevMonthDate.getMonth() + 1;
const defaultYear = prevMonthDate.getFullYear();

type Props = {
  managerId: number | null;
};

export const SalaryInfo = ({ managerId }: Props) => {
  const [period, setPeriod] = useState<{ month: number; year: number } | null>({
    month: defaultMonth,
    year: defaultYear,
  });

  const hasPeriod = period?.month != null && period?.year != null;
  const month = period?.month ?? defaultMonth;
  const year = period?.year ?? defaultYear;

  const { data: managerSalary, refetch: refetchSalary } = useGetManagerMonthlySalary(
    managerId,
    hasPeriod ? period!.month : undefined,
    hasPeriod ? period!.year : undefined
  );

  const handlePeriodChange = (month: number, year: number) => {
    setPeriod({ month, year });
  };

  return (
    <>
      <SalaryTable
        managerId={managerId}
        month={period?.month}
        year={period?.year}
        onPeriodChange={handlePeriodChange}
        onPeriodClear={() => setPeriod(null)}
      />
      <SalaryCalculation
        managerId={managerId}
        month={month}
        year={year}
        managerSalary={managerSalary}
        refetchSalary={refetchSalary}
      />
    </>
  );
};
